export default __webpack_public_path__ + "static/media/logo-manole-play.a2bfdab3.svg";